import { ApiUrls, Environments, StreamingApiUrls } from '@tda/utilities';
import { ChatClient } from '../api-interaction/chat-http-client';
import { ChatStreamClient } from '../api-interaction/chat-stream-client';

export function initializeTdaChat(environment: Environments, tokenProvider?: () => Promise<string>) {
  ChatClient.setInstance(ApiUrls[environment], tokenProvider);
  ChatStreamClient.setInstance(StreamingApiUrls[environment], tokenProvider);
}
